import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const YesNoPill = ({ value }: { value: boolean | null }) => {
  const { t } = useTranslation();
  return (
    <Badge
      bg="smBackgroundSecondary"
      color={value == null ? "smMuted" : "smText"}
      px="2.5"
      py="1"
      borderRadius="full"
      textTransform="none"
      fontWeight="medium"
      whiteSpace="nowrap"
      flexShrink={0}
    >
      {value == null ? t("Not answered") : value ? t("Yes") : t("No")}
    </Badge>
  );
};
